module.exports = __webpack_public_path__ + "static/media/trolleybus.3d9fbdee.svg";